import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { searchTeachers, type TeacherSearchParams, type TeacherSearchResult, type TeacherSearchPageResponse } from '@/services/marketplaceSearchService';

export function useTeacherSearch(params: TeacherSearchParams, enabled = true) {
  return useQuery<TeacherSearchPageResponse>({
    queryKey: ['marketplace-teachers', params],
    queryFn: () => searchTeachers(params),
    enabled,
    staleTime: 30_000,
  });
}

/** "Load more" variant — pages accumulate at `data.pages` instead of a single `data`. */
export function useTeacherSearchInfinite(params: Omit<TeacherSearchParams, 'page'>, enabled = true) {
  return useInfiniteQuery<TeacherSearchPageResponse>({
    queryKey: ['marketplace-teachers', 'infinite', params],
    queryFn: ({ pageParam }) => searchTeachers({ ...params, page: pageParam as number }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => (lastPage.number + 1 < lastPage.totalPages ? lastPage.number + 1 : undefined),
    enabled,
    staleTime: 30_000,
  });
}

/** Top Coaches landing carousel — teachers ranked by rolling-30-day profile views, loaded a page at a time. */
export function useTopCoaches(size = 8) {
  return useTeacherSearchInfinite({ sortBy: 'POPULARITY', size });
}

export type { TeacherSearchResult, TeacherSearchParams };
